module.exports = __webpack_public_path__ + "static/img/product-8.3897931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-8.png
// module id = vKD4
// module chunks = 0